import { ActionTypes } from '../../constants';
import { polyglot } from '../../assets/locales';
import update from 'immutability-helper';

class ImprovementPrivateActions {
  static setImprovements(improvements) {
    return {
      type: ActionTypes.SET_IMPROVEMENT,
      payload: {
        improvements,
      },
    };
  }
}

class ImprovementActions {
  /**
   * takes in a new improvement object and appends it to existing improvements array
   * @param {Object} newImprovement  - newly initialized improvement object
   */
  static appendImprovement() {
    return function (dispatch, getState) {
      const newImprovement = {
        id: new Date().getTime(),
        title: '',
        cost: '',
        units: '',
        calculatedAmount: '',
        submitDisabled: false,
        checked: false,
        errors: {
          title: polyglot.t('errors.title.empty'),
          cost: polyglot.t('errors.cost.empty'),
          units: polyglot.t('errors.units.empty'),
          submit: polyglot.t('errors.submit'),
        },
      };
      const improvements = getState().improvements.list;
      dispatch(ImprovementPrivateActions.setImprovements([...improvements, newImprovement]));
    };
  }

  /**
   * takes in an existing improvement object and creates a new improvements array with the spliced in/updated object
   * @param {Number} id  - id of object to be updated
   * @param {Object} id  - improvement object to be updated
   */
  static updateImprovement(id, updateObject) {
    return (dispatch, getState) => {
      const improvements = getState().improvements.list;
      const updateIndex = improvements.findIndex((improvement) => improvement.id === id);

      const updatedImprovements = update(improvements, {
        $splice: [[updateIndex, 1, updateObject]],
      });

      dispatch(ImprovementPrivateActions.setImprovements(updatedImprovements));
    };
  }

  /**
   * Deletes improvement with passed in id from array
   * @param {Number} id  - id of object to be deleted
   */
  static deleteImprovement(id) {
    return (dispatch, getState) => {
      const improvements = getState().improvements.list;
      const deletedImprovements = improvements.filter((improvement) => {
        return improvement.id !== id;
      });

      dispatch(ImprovementPrivateActions.setImprovements(deletedImprovements));
    };
  }
  /**
   * resets to page 1 and clears all redux storage data to initial default state
   */
  static resetImprovements() {
    return {
      type: ActionTypes.RESET_IMPROVEMENTS,
    };
  }
  /**
   *
   * @param {Boolean} bool - true/false passed in when the continueButton is clicked
   */
  static submitStep1(bool) {
    return {
      type: ActionTypes.CONTINUE_CLICKED,
      payload: {
        continueClicked: bool,
      },
    };
  }

  /**
   * sets step to 1, and causes page 1 to render
   */
  static goToStep1() {
    return {
      type: ActionTypes.UPDATE_STEP,
      payload: {
        currentStep: 1,
      },
    };
  }

  /**
   * sets step to 2, and causes page 2 to render
   */
  static goToStep2() {
    return {
      type: ActionTypes.UPDATE_STEP,
      payload: {
        currentStep: 2,
      },
    };
  }
}

export default ImprovementActions;